const Flash = ({ color }: { color?: string }) => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32.1031 14.7808H24.5733L31.3443 6.22559C31.4844 6.04443 31.358 5.78125 31.129 5.78125H18.0211C17.9254 5.78125 17.8331 5.83252 17.7852 5.91797L8.92927 21.2134C8.82332 21.3945 8.9532 21.6235 9.16511 21.6235H15.1261L12.0704 33.8462C12.0054 34.1128 12.3267 34.3008 12.525 34.1094L32.2911 15.249C32.4688 15.0815 32.3492 14.7808 32.1031 14.7808ZM16.0455 27.5366L18.1065 19.2993H12.7266L19.2071 8.10889H26.8839L19.7642 17.1084H26.9761L16.0455 27.5366Z" fill={color ?? "#C7C7C7"}/>
    </svg>
  );
}
export default Flash;
